import { Link } from 'react-router-dom';
import { ROUTES } from '../Routes';
import { usePageTitle } from '../hooks/usePageTitle';

const RegisterPage = () => {
    usePageTitle('Register');

    return (
        <div className='wp-singular page-template-default page page-id-10 wp-theme-ppc2'>
            <header>
                <div className="container">
                    <div className="header-content">
                        <Link to="/" className="logo">
                            Torox Games </Link>

                        <div className="user-menu">
                            <div className="auth-buttons">
                                <Link to={ROUTES.LOGIN}>Login</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <main>
                <div className="container">
                    <div className="disclaimer-banner">
                        <h2>⚠️ SOCIAL CASINO REGISTRATION ⚠️</h2>
                        <p>Get 5000 FREE virtual points - No real money involved - Entertainment only</p>
                    </div>

                    <div
                        style={{background: '#ff6b6b', color: 'white', padding: '1rem', borderRadius: '5px', textAlign: 'center', marginBottom: '2rem' }}>
                    </div>

                    <form id="p-register-form" className="auth-form" method="post">
                        <h2>Create New Account</h2>
                        <div className="form-group">
                            <label htmlFor="reg_username">Username</label>
                            <input type="text" id="reg_username" name="username" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="reg_email">Email</label>
                            <input type="email" id="reg_email" name="email" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="reg_password">Password</label>
                            <input type="password" id="reg_password" name="password" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="reg_password_confirm">Confirm Password</label>
                            <input type="password" id="reg_password_confirm" name="password_confirm" required />
                        </div>
                        <button type="submit" className="submit-btn">Register & Get 5000 Points</button>
                        <div className="form-toggle">
                            <p>Already have an account? <Link to={ROUTES.LOGIN}>Login here</Link></p>
                        </div>
                    </form>
                </div>
            </main>

            <footer>
                <div className="container">
                    <div className="footer-content"
                        style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem', marginBottom: '2rem' }}>
                        <div className="footer-section">
                            <h4 style={{ color: '#00ffff', marginBottom: '1rem' }}>Legal Information</h4>
                            <p style={{ color: '#ccc', fontSize: '0.9rem', lineHeight: '1.6' }}>
                                SF2 SIA<br />
                                Kr. Valdemara iela 33-7<br />
                                LV-1010 Riga, Latvia<br />
                                Reg. no 40103691516
                            </p>
                        </div>

                        <div className="footer-section">
                            <h4 style={{ color: '#00ffff', marginBottom: '1rem' }}>Important Links</h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                <Link to={ROUTES.TERMS_AND_CONDITIONS}
                                    style={{ color: '#ccc', textDecoration: 'none', fontSize: '0.9rem' }}>Terms and Conditions</Link>
                                <Link to={ROUTES.PRIVACY_POLICY}
                                    style={{ color: '#ccc', textDecoration: 'none', fontSize: '0.9rem' }}>Privacy Policy</Link>
                                <Link to={ROUTES.ABOUT_US}
                                    style={{ color: '#ccc', textDecoration: 'none', fontSize: '0.9rem' }}>About Us</Link>
                                <Link to={ROUTES.CONTACT_US}
                                    style={{ color: '#ccc', textDecoration: 'none', fontSize: '0.9rem' }}>Contact Us</Link>
                            </div>
                        </div>

                        <div className="footer-section">
                            <h4 style={{ color: '#00ffff', marginBottom: '1rem' }}>Contact Information</h4>
                            <p style={{ color: '#ccc', fontSize: '0.9rem', lineHeight: '1.6' }}>
                                Email: <a href="/cdn-cgi/l/email-protection" className="__cf_email__"
                                    data-cfemail="b8d1d6ded7f8dcd9cad3d5d9d6cbd1d7d6dfd9d5ddcb96dbd7d5">info@Torox.site</a><br />
                                Website: https://Torox.site </p>
                        </div>
                    </div>

                    <div className="footer-bottom"
                        style={{borderTop: 1, borderStyle: 'solid', borderColor: 'rgba(255, 215, 0, 0.3)', paddingTop: '2rem', textAlign: 'center' }}>
                        <p>&copy; 2026 Torox Games. Entertainment only - No real money gambling.</p>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default RegisterPage